export class LocationClassification {
    /* TOLO-1974 - TOLO shouln't support revenue location type, but API returns all type of locations */
    public static filterOutRevenue(virtualLocations: OLO.DTO.VirtualLocationBusinessModel[]): OLO.DTO.VirtualLocationBusinessModel[] {
        return virtualLocations.filter(virtualLocation =>
            virtualLocation.LocationClassification !== OLO.Enums.LOCATION_CLASSIFICATION.REVENUE_AGREGATOR_LOCATION);
    }
}
